
import React, { Component, Fragment } from 'react';
import { Route } from 'react-router';
import { BrowserRouter as Router, Switch, Link } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/Home';

import addCredito from './components/addCredito';
import VerCreditos from './components/VerCreditos';
import EditCredito from './components/EditCredito';
import solicitudDetail from './components/solicitudDetail';
import RevisarCreditosAdmin from './components/RevisarCreditosAdmin';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import  VerDocumentos from './components/VerDocumentos';
import './custom.css'

export default class App extends Component {
    static displayName = App.name;
  
   
 
    render() {
        
        return (<div>
          <Layout >
        <AuthorizeRoute exact path='/' component={Home} />
        <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
         <AuthorizeRoute path='/addCredito' component={addCredito} />
            <AuthorizeRoute path='/VerCreditos' component={VerCreditos} />
            <AuthorizeRoute path='/RevisarCreditosAdmin' component={RevisarCreditosAdmin} />
      </Layout>
      <br />
      <Switch>
            <AuthorizeRoute path='/solicitudDetail/:id' component={solicitudDetail} />
                <AuthorizeRoute path='/EditCredito/:id' component={EditCredito} />   
                <AuthorizeRoute path='/VerDocumentos/:id' component={VerDocumentos} />   
          </Switch>
          </div >
    );
  }
}
